import { FXAAEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const FXAA = wrapEffect(FXAAEffect)
